/* eslint-disable no-param-reassign */
(function () {
    // Check if the module exists before doing anything
    const reputationHeading = document.querySelectorAll(
        '.reputation__item__heading'
    );

    if (reputationHeading) {
        reputationHeading.forEach((item) => {
            const headingLength = item.innerHTML.trim().split(/\s+/).length;
            let replacement = null;

            // item.innerHTML.replace(/(^|<\/?[^>]+>|\s+)([^\s<]+)/g, '<span>$&</span>');
            if (headingLength > 1) {
                replacement = item.innerHTML.replace(
                    /(^|<\/?[^>]+>|\s+)([^\s<]+)/g,
                    '<span>$&</span>'
                );
                item.innerHTML = replacement;
            }
        });
    }
})();
